'use strict';

angular.module('atex.dam').filter('rows', function() {
	return function (input, total) {
	    total = parseInt(total);
	    for (var i = 0; i < total; i++) {
	        input.push(i);
	    }
	    return input;
	};
});


angular.module('atex.dam').filter('capitalize', function() {
  return function(input) {
    return (!!input) ? input.charAt(0).toUpperCase() + input.substring(1).toLowerCase() : '';
  };
});
